import React from 'react';
import { Link } from 'react-router-dom';
import { Separator } from './ui/separator';
export function Footer() {
  return <footer className="bg-navy text-white" data-id="element-19">
      <div className="container mx-auto px-4 lg:px-8 py-10 md:py-12" data-id="element-20">
        <div className="flex flex-col items-center text-center space-y-6" data-id="element-21">
          {/* Logo & Name */}
          <div className="flex items-center space-x-3" data-id="element-22">
            <img src="https://cdn.magicpatterns.com/uploads/hWmdhijhRkkJmHjpaF6M76/smg-logo.png" alt="Strategic Metals Group" className="h-14 w-14 object-contain" data-id="element-23" />
            <span className="font-heading text-lg font-semibold text-white" data-id="element-24">
              Strategic Metals Group
            </span>
          </div>

          {/* Tagline */}
          <p className="text-sm text-steel max-w-md" data-id="element-25">
            Global advisory for precious metals, mining, and strategic
            partnerships.
          </p>

          {/* Nav Links */}
          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-26">
            {[{
            name: 'About',
            path: '/about'
          }, {
            name: 'Services',
            path: '/services'
          }, {
            name: 'Leadership',
            path: '/leadership'
          }, {
            name: 'Global Network',
            path: '/global-network'
          }, {
            name: 'Contact',
            path: '/contact'
          }].map(link => <Link key={link.path} to={link.path} className="text-sm text-steel hover:text-gold transition-colors" data-id="element-27">
                {link.name}
              </Link>)}
          </nav>

          <Separator className="w-full max-w-xs bg-gold/20" data-id="element-28" />

          {/* Copyright */}
          <div className="text-xs text-steel/70" data-id="element-29">
            © {new Date().getFullYear()} Strategic Metals Group Inc. All rights
            reserved.
          </div>
        </div>
      </div>
    </footer>;
}